import { useGetStockOutQuery } from '@/features/slice/inventory';
import { useStockListApiQueryParams } from '@/modules/stocks/shared';

export const useStockOutList = () => {
    const queryParams = useStockListApiQueryParams();

    const { data, isFetching, isLoading, isError, error } =
        useGetStockOutQuery(queryParams);
    return {
        data,
        error,
        isFetching,
        isLoading,
        isError,
    };
};
